import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config/config.service';
import { getQueryStringFromObject } from '../../../../../common/utils/helpers';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { HttpHeaders } from '@angular/common/http';
import { RequestHeader } from '../../../../constants/headers';
import { Language } from '../../../../../common/constants';
import { NewsletterSubscriptionEndpoint } from '../constants/newsletter-subscription-endpoint';

@Injectable({
  providedIn: 'root',
})
export class NewsletterSubscriptionService {
  constructor(private http: WrapperHttpService) {}

  confirmNewsletterSubscription(token: string): Observable<void> {
    return this.http.withLoading().post<void>(
      `${API_URL}${NewsletterSubscriptionEndpoint.Confirm}?${getQueryStringFromObject({
        token,
      })}`,
      {},
      {
        headers: new HttpHeaders({
          [RequestHeader.SkipInterceptor]: '',
        }),
      },
    );
  }

  newsletterSubscribe(lang: Language): Observable<void> {
    return this.http.withLoading().post<void>(
      `${API_URL}${NewsletterSubscriptionEndpoint.Subscribe}?${getQueryStringFromObject({
        lang,
      })}`,
      {},
    );
  }
}
